import getTextFromChildren from './get-text-from-children';
const getAriaLabel = ({
  ariaLabel,
  name,
  children,
  href
}) => {
  if (ariaLabel) return ariaLabel;
  if (name) return name;
  if (children) {
    const textFromChildren = getTextFromChildren(children);
    if (textFromChildren) return textFromChildren;
  }
  if (href) {
    return href === '/' ? 'Home' : `Open ${href}`;
  }
  return null;
};
export default getAriaLabel;
//# sourceMappingURL=get-aria-label.js.map